import React from "react";
import "../../css/tooltip.css"; 

const Tooltip = ({ text, children }) => {
    return (
        <div className="tooltip-wrapper">
            {children}
            <div className="custom-tooltip">{text}</div>
        </div>
    );
};

export default Tooltip;
